import { Box } from '@opendoor/atoms/box';
import { cn } from '@opendoor/atoms/utils';

// Atoms bans margin utilities, so callers space the rule with vertical padding
// (e.g. `py-4`, `pt-12`) on the wrapper; the 1px line stays centered between the
// padding. `m-0` is the only allowed margin and is unnecessary here.
type DividerProps = Omit<React.ComponentProps<typeof Box>, 'children' | 'onClick' | 'href'>;

export const Divider: React.FC<DividerProps> = ({ className, ...props }) => {
  return (
    <Box {...props} className={cn('w-full', className)}>
      <Box
        role="separator"
        aria-orientation="horizontal"
        className="h-px w-full bg-od-border-secondary"
      />
    </Box>
  );
};
